export default import.meta.ROLLUP_FILE_URL_pe$fBG0k;